module.exports = __webpack_public_path__ + "static/media/catsonurhead.38817f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/avatars/catsonurhead.png
// module id = 35
// module chunks = 0